import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useGetUrlParam(key) {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    return params.get(key);
}


export function useAllUrlParams() {
    const { search } = useLocation();

    return useMemo(() => {
        const params = new URLSearchParams(search);
        const result = {};

        for (const [key, value] of params.entries()) {
            result[key] = value;
        }

        return result;
    }, [search]);
}